/**
 * Product FAQ accordion: only one open at a time. Opening one closes any other.
 * Re-runs on shopify:section:load.
 */
(function () {
  var hasCustomerReviewsScrollHandlerBound = false;

  function closeAllExcept(container, exceptItem) {
    var items = container.querySelectorAll('.product-faq__item');
    items.forEach(function (it) {
      if (it === exceptItem) return;
      it.classList.remove('is-open');
      var trigger = it.querySelector('[data-product-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var controlsId = trigger && trigger.getAttribute('aria-controls');
      var panel = controlsId ? container.querySelector('[data-product-faq-panel][id="' + controlsId + '"]') : null;
      if (panel) panel.hidden = true;
    });
  }

  function initFaq(container) {
    if (!container || container._productFaqInit) return;
    container._productFaqInit = true;

    var triggers = container.querySelectorAll('[data-product-faq-trigger]');

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.product-faq__item');
        var panel = container.querySelector('[data-product-faq-panel][id="' + btn.getAttribute('aria-controls') + '"]');
        var isOpen = item && item.classList.contains('is-open');

        if (isOpen) {
          if (item) item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        } else {
          closeAllExcept(container, item);
          if (item) item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
        }
      });
    });
  }

  function run() {
    document.querySelectorAll('[data-product-faq]').forEach(initFaq);
    bindCustomerReviewsScroll();
  }

  function getNavbarOffsetHeight() {
    var header = document.querySelector('header.gaurya-navbar');
    if (!header || typeof header.offsetHeight !== 'number') return 0;
    var computedStyle = window.getComputedStyle(header);
    var position = computedStyle ? computedStyle.position : '';
    var isOverlay =
      position === 'fixed' || position === 'sticky' || position === 'absolute' || position === 'top';
    return isOverlay ? header.offsetHeight : 0;
  }

  function scrollToCustomerReviewsHeading() {
    var heading = document.getElementById('customer-reviews-heading');
    if (!heading) return;

    var navbarOffset = getNavbarOffsetHeight();
    var extraOffset = 10;
    var y = heading.getBoundingClientRect().top + window.pageYOffset - navbarOffset - extraOffset;
    if (y < 0) y = 0;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = prefersReducedMotion ? 'auto' : 'smooth';

    window.scrollTo({ top: y, behavior: behavior });
  }

  function bindCustomerReviewsScroll() {
    if (hasCustomerReviewsScrollHandlerBound) return;
    hasCustomerReviewsScrollHandlerBound = true;

    // Use capture-phase to beat Judge.me's own click handler (if any).
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var anchor = target.closest('a[href="#customer-reviews-heading"]');
        if (!anchor) return;

        event.preventDefault();
        event.stopPropagation();

        // Ensure the URL hash is consistent without triggering a native jump.
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#customer-reviews-heading');
        }

        scrollToCustomerReviewsHeading();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.querySelector && section.querySelector('[data-product-faq]')) {
      var list = section.querySelector('[data-product-faq]');
      if (list) list._productFaqInit = false;
      initFaq(list);
    }
  });
})();
